import { Dispatch } from 'redux';

import { requestHandler } from '../../../api';

export const pruffConnectGetReceivedInvoices = async (
  dispatch: Dispatch,
  clientId: string,
  query: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/express/${clientId}/billing/invoices?${query}`,
    dispatch,
  });
  if (response) return response.data;
};
